import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'DateFormat' })
export class DateFormatPipe implements PipeTransform {

  transform(date: Date | string): string {
    if (date) return moment(date).format('D MMM YYYY');
    return '-';
  }
}

@Pipe({ name: 'ShortDateFormat' })
export class ShortDatePipe implements PipeTransform {

  transform(date: Date | string): string {
    if (date) return moment(date).format('MMM D');
    return '-';
  }
}
